import { DashboardState } from "../../Models/DashboardState";
import { Index, IndexGroup } from "../../Models/Indexes";
import { findGroupAndNameBySearchIndexId, setLocalStorageSearchIndexId, setLocalStorageSearchIndexKey } from "../../Utils/Common";
import {
  FETCH_ANNOUNCEMENTS_FAILURE,
  FETCH_ANNOUNCEMENTS_REQUEST,
  FETCH_ANNOUNCEMENTS_SUCCESS,
  FETCH_INDEXES_FAILURE,
  FETCH_INDEXES_REQUEST,
  FETCH_INDEXES_SUCCESS,
  SET_DEFAULT_INDEXES,
  SET_INDEX_KEY_AND_VALUE,
  SET_SELECTED_INDEX,
  SET_SELECTED_SUB_INDEX,
  UPDATE_HEADER_INDEX_KEY_AND_VALUE,
  SET_DEEPSEARCH_MODE,
  SET_DEEPSEARCH_MODE_FALSE,
  SET_USE_ONLY_EXTERNAL_DOCUMENTS,
  SET_USE_ONLY_EXTERNAL_DOCUMENTS_FALSE,
  HAS_EXTERNAL_UPLOADED_DOCUMENTS
} from "./DashboardTypes";

const initialState: DashboardState = {
  loading: false,
  indexesLoading: false,
  announcementsLoading: false,
  deepSearchActive: false,
  useOnlyAttachedDocuments: false,
  hasExternalUploadedDocuments: false,
  indexes: {},
  announcements: [],
  error: "",
  keys: [],
  selectedIndex: null,
  searchIndexId: "",
  selectedSubIndexes: [],
  selectedSubIndexesKey: null,
  documents: 0,
  pages: 0,
  drafts: []
};

const DashboardReducer = (state = initialState, action: any): DashboardState => {
  switch (action.type) {
    case FETCH_INDEXES_REQUEST:
      return { ...state, indexesLoading: true };
    case FETCH_INDEXES_SUCCESS: {
      const searchIndexKey = localStorage.getItem("SearchIndexKey");
      const searchIndexId = localStorage.getItem("SearchIndexId");
      const keys = action.payload.map((item : IndexGroup) => item.group);

      const getIndexesByGroupName = (groupName: string) => {
        const groupData = action.payload.find((item:IndexGroup) => item.group === groupName);
        return groupData ? groupData.indexes : [];
      };

      const getIndexByGroupAndId = (groupName: string, searchIndexId: string) => {
        const groupData = action.payload.find((item:IndexGroup) => item.group === groupName);
        if (!groupData) return null; // Return null if group is not found
      
        return groupData.indexes.find((index:Index) => index.searchIndexId === searchIndexId) || null;
      };

      const buildState = (selectedIndex: string, selectedSubIndex: any) => ({
        ...state,
        indexesLoading: false,
        indexes: action.payload,
        keys: keys,
        selectedIndex: selectedIndex,
        searchIndexId: selectedSubIndex.searchIndexId,
        selectedIndexValue: selectedSubIndex.value,
        selectedSubIndexes: getIndexesByGroupName(selectedIndex),
        selectedSubIndexesKey: selectedSubIndex.name,
        documents: selectedSubIndex.documents,
        drafts: selectedSubIndex.drafts,
        pages: selectedSubIndex.pages,
        error: "",
      });

      if (searchIndexKey && searchIndexId) {
        const selectedSubIndex = getIndexByGroupAndId(searchIndexKey, searchIndexId);
        return buildState(searchIndexKey, selectedSubIndex);

      } else {
        const selectedIndex = keys[0];
        const selectedSubIndexes = getIndexesByGroupName(selectedIndex);
        const selectedSubIndex = selectedSubIndexes[0];

        setLocalStorageSearchIndexKey(selectedIndex);
        setLocalStorageSearchIndexId(selectedSubIndex.searchIndexId);
        return buildState(selectedIndex, selectedSubIndex);
      }
    }
    case FETCH_INDEXES_FAILURE:
      return { ...state, indexesLoading: false, indexes: {}, error: action.payload };
    case SET_SELECTED_INDEX:
      return {
        ...state,
        loading: false,
        selectedIndex: action.payload.selectedIndex,
        searchIndexId: action.payload.searchIndexId,
        selectedSubIndexes: action.payload.selectedSubIndexes,
        selectedSubIndexesKey: action.payload.selectedSubIndexesKey,
        documents: action.payload.documents,
        drafts: action.payload.drafts,
        pages: action.payload.pages,
        error: "",
      };
    case SET_SELECTED_SUB_INDEX:
      const subIndexes = state.selectedSubIndexes.find((item) => item.name === action.payload);
      return { ...state, loading: false, selectedSubIndexesKey: action.payload, documents: subIndexes.documents, pages: subIndexes.pages, drafts: subIndexes.drafts, error: "" };
    case FETCH_ANNOUNCEMENTS_REQUEST:
      return { ...state, announcementsLoading: true };
    case FETCH_ANNOUNCEMENTS_SUCCESS:
      return { ...state, announcementsLoading: false, announcements: action.payload };
    case FETCH_ANNOUNCEMENTS_FAILURE:
      return { ...state, announcementsLoading: false, error: action.payload };
    case SET_DEFAULT_INDEXES:
      const defaultConversationSubIndexes = state.indexes[action.payload.indexKey];
      const defaultConversationSubIndex = defaultConversationSubIndexes.find((m: any) => m.name === action.payload.indexValue);
      return {
        ...state,
        selectedIndex: action.payload.indexKey,
        searchIndexId: defaultConversationSubIndex.searchIndexId,
        selectedSubIndexes: defaultConversationSubIndexes,
        selectedSubIndexesKey: defaultConversationSubIndex.name,
        documents: defaultConversationSubIndex.documents,
        drafts: defaultConversationSubIndex.drafts,
        pages: defaultConversationSubIndex.pages,
      };
    case SET_INDEX_KEY_AND_VALUE:
      return { ...state, selectedIndex: action.payload.indexKey, selectedSubIndexesKey: action.payload.indexValue }
    case UPDATE_HEADER_INDEX_KEY_AND_VALUE:
      const result = findGroupAndNameBySearchIndexId(state.indexes, action.payload)
      return { ...state, selectedIndex: result.groupName, searchIndexId: action.payload, selectedSubIndexesKey: result.name, drafts: result.drafts }
    case SET_DEEPSEARCH_MODE:
      return { ...state, deepSearchActive: !state.deepSearchActive };
    case SET_DEEPSEARCH_MODE_FALSE:
      return { ...state, deepSearchActive: false };
    case SET_USE_ONLY_EXTERNAL_DOCUMENTS:
      return { ...state, useOnlyAttachedDocuments: !state.useOnlyAttachedDocuments };
    case SET_USE_ONLY_EXTERNAL_DOCUMENTS_FALSE:
      return { ...state, useOnlyAttachedDocuments: false };
    case HAS_EXTERNAL_UPLOADED_DOCUMENTS:
      return { ...state, hasExternalUploadedDocuments: action.payload > 0,  deepSearchActive: action.payload > 0 ? false : state.deepSearchActive, useOnlyAttachedDocuments: action.payload > 0 ? true : state.useOnlyAttachedDocuments };
    default:
      return state;
  }
};

export default DashboardReducer;
